<article class="block type-flex">
  <!-- SIDE BAR -->
  <div class="col-left">
    <header class="block-header">
      <h1 class="block-header-title">TP-{{ project.TPNumber }} {{ project.Title }}</h1>
      <a
        class="button button-ionBiz"
        target="_blank"
        *ngIf="project.IonBIZ_Id && project.IonBIZ_Id > 0"
        [href]="'https://mvrdv.ionbiz.com/Project/Index/' + project.IonBIZ_Id"
      >
        Open in ionBIZ
      </a>
      <div class="block-header-text">
        <p [innerHTML]="project.Summary"></p>
      </div>
    </header>

    <ol class="form-wizard-chapters-list">
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 0 }">
        <a class="form-wizard-chapter-link no--number" (click)="switchTab(0)">General info & photos</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 1 }">
        <a class="form-wizard-chapter-link no--number" (click)="switchTab(1)">Teams</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 2 }">
        <a class="form-wizard-chapter-link no--number" (click)="switchTab(2)">Sustainability</a>
      </li>
    </ol>
  </div>

  <!-- CONTENT -->
  <div class="col-right type-project-detail">
    <!-- TAB: TEAMS -->
    <app-expansion-panel [title]="'Teams'" [active]="hidePanels.includes('teams')" (toggle)="togglePanel('teams')" *ngIf="activeTab === 1">
      <dl class="block-group-list" *ngFor="let team of project.Teams">
        <dt class="block-group-heading is--inline">{{ team.Title }}:</dt>
        <dd class="block-group-item">
          <strong>{{ team.PhaseStart | date: 'MM/dd/yyyy' }} - {{ team.PhaseEnd | date: 'MM/dd/yyyy' }}</strong>
        </dd>
        <dd class="block-group-item is--comma" *ngFor="let member of team.Members">
          <a href="#">{{ member.Name }}</a>
        </dd>
        <div *ngFor="let subTeams of team.Subgroups">
          <dt class="block-group-heading is--inline">{{ subTeams.Title }}:</dt>
          <dd class="block-group-item is--comma" *ngFor="let member of subTeams.Members">
            <a href="#">{{ member.Name }}</a>
          </dd>
        </div>
        <dt class="block-group-heading is--inline" *ngIf="team.ExternalTeams">External teams:</dt>
        <dd class="block-group-item is--inline">{{ team.ExternalTeams }}</dd>
      </dl>
    </app-expansion-panel>

    <!-- TAB: Sustainability -->
    <section *ngIf="activeTab === 2">
      <div
        class="sustainability__intro"
        [innerText]="
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem reiciendis similique, quo, repellat vel, doloribus numquam nam autem recusandae nesciunt reprehenderit aliquam eum cupiditate perspiciatis totam esse. Nihil debitis maxime pariatur perferendis, atque sed odit necessitatibus asperiores illo! Excepturi, qui.'
        "
      ></div>
      <app-expansion-panel [title]="'Certificates'" [active]="hidePanels.includes('certificates')" (toggle)="togglePanel('certificates')">
        <ul>
          <li *ngFor="let cert of certificates">
            <app-sdg-certificate [label]="cert.name" [value]="cert.value" [total]="cert.levels" [level]="cert.level"></app-sdg-certificate>
          </li>
        </ul>
      </app-expansion-panel>
      <app-expansion-panel
        [title]="'Sustainability'"
        [active]="hidePanels.includes('sustainability')"
        (toggle)="togglePanel('sustainability')"
      >
        <ng-container *ngIf="project.SustainabilityPhaseDocument">
          <h3 class="core-sdg__title">Sustainability phase document</h3>
          <ul class="core-sdg__list">
            <li class="core-sdg__list__item is--active">
              <p>{{ project.SustainabilityPhaseDocument }}</p>
            </li>
          </ul>
        </ng-container>

        <ul class="sdg-grid">
          <li *ngFor="let number of sdgGoalNumbers" class="sdg-grid__item">
            <svg class="icon-svg sdg" [class.is--inactive]="selectedSDGs?.indexOf('SDG' + (number < 9 ? '0' : '') + (number + 1)) < 0">
              <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#goal-' + (number + 1)"></use>
            </svg>
          </li>
        </ul>
      </app-expansion-panel>
      <app-expansion-panel [title]="'Core SDG\'s'" [active]="hidePanels.includes('coresdg')" (toggle)="togglePanel('coresdg')">
        <!-- SDG 11 -->
        <div class="core-sdg">
          <div class="core-sdg__image">
            <svg class="icon-svg sdg">
              <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#goal-11'"></use>
            </svg>
          </div>
          <div class="core-sdg__content sgd-11-content">
            <ul class="core-sdg__list" [class.mb-0]="!project.SDG11_Health || !project.SDG11_Ecology || !project.SDG11_SROI">
              <li class="core-sdg__list__item" [class.is--active]="project.SDG11_Health">
                <svg class="icon-svg icon-check" *ngIf="project.SDG11_Health">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>

                {{ project.SDG11_Health ? 'Health' : 'No Health' }}
              </li>
              <li class="core-sdg__list__item" [class.is--active]="project.SDG11_Ecology">
                <svg class="icon-svg icon-check" *ngIf="project.SDG11_Ecology">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>

                {{ project.SDG11_Ecology ? 'Ecology' : 'No Ecology' }}
              </li>
              <li class="core-sdg__list__item" [class.is--active]="project.SDG11_SROI">
                <svg class="icon-svg icon-check" *ngIf="project.SDG11_SROI">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>

                {{ project.SDG11_SROI ? 'SROI' : 'No SROI' }}
              </li>
            </ul>
          </div>
        </div>

        <!-- SDG 12 -->
        <div class="core-sdg">
          <div class="core-sdg__image">
            <svg class="icon-svg sdg">
              <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#goal-12'"></use>
            </svg>
          </div>
          <div class="core-sdg__content">
            <!-- <h3 class="core-sdg__title">Has reduction strategy</h3> -->
            <ul class="core-sdg__list">
              <li class="core-sdg__list__item" [class.is--active]="project.SDG12_ReductionStrategy">
                <svg class="icon-svg icon-check" *ngIf="project.SDG12_ReductionStrategy">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>
                {{ project.SDG12_ReductionStrategy ? 'reduction strategy' : 'No reduction strategy' }}
              </li>
            </ul>
            <div *ngIf="project.SDG12_Method | split: ',' as methods">
              <h3 class="core-sdg__title">Selected methods</h3>
              <ul class="core-sdg__list">
                <li class="core-sdg__list__item is--active" *ngFor="let m of methods">
                  <svg class="icon-svg icon-check" *ngIf="project.SDG12_ReductionStrategy">
                    <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                  </svg>
                  {{ m }}
                </li>
              </ul>
            </div>
            <div *ngIf="project.SDG12_MethodText">
              <h3 class="core-sdg__title">Method</h3>
              <p class="pre-line">{{ project.SDG12_MethodText }}</p>
            </div>
          </div>
        </div>

        <!-- SDG 13 -->
        <div class="core-sdg sgd-13-content">
          <div class="core-sdg__image">
            <svg class="icon-svg sdg">
              <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#goal-13'"></use>
            </svg>
          </div>
          <div class="core-sdg__content no--border mb-0">
            <!-- <h3 class="core-sdg__title">Has Embodied carbon strategy</h3> -->
            <ul class="core-sdg__list" [class.mb-0]="!project.SDG13_EmbodiedCarbonStrategy">
              <li class="core-sdg__list__item" [class.is--active]="project.SDG13_EmbodiedCarbonStrategy">
                <svg class="icon-svg icon-check" *ngIf="project.SDG13_EmbodiedCarbonStrategy">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>
                {{ project.SDG13_EmbodiedCarbonStrategy ? 'Embodied carbon strategy' : 'No Embodied carbon strategy' }}
              </li>
              <li *ngIf="project.SDG13_EmbodiedCarbon">
                Embodied carbon:
                <strong>{{ project.SDG13_EmbodiedCarbon }} KG/M2</strong>
              </li>
            </ul>

            <!-- <div *ngIf="project.SDG13_EmbodiedCarbon">
              <h3 class="core-sdg__title">Embodied carbon</h3>
              <ul class="core-sdg__list">
                <li class="core-sdg__list__item is--active">{{ project.SDG13_EmbodiedCarbon }} KG/M2</li>
              </ul>
            </div> -->

            <!-- <h3 class="core-sdg__title">Has Operational carbon strategy</h3> -->
            <ul class="core-sdg__list" [class.mb-0]="!project.SDG13_OperationalCarbonStrategy">
              <li class="core-sdg__list__item" [class.is--active]="project.SDG13_OperationalCarbonStrategy">
                <svg class="icon-svg icon-check" *ngIf="project.SDG13_EmbodiedCarbonStrategy">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>
                {{ project.SDG13_OperationalCarbonStrategy ? 'Operational carbon strategy' : 'No Operational carbon strategy' }}
              </li>
              <li *ngIf="project.SDG13_OperationalCarbonStrategyText">
                <p class="pre-line">{{ project.SDG13_OperationalCarbonStrategyText }}</p>
              </li>
              <li *ngIf="project.SDG13_OperationalCarbon">
                Operational carbon:
                <strong>{{ project.SDG13_OperationalCarbon }} KG/M2</strong>
              </li>
            </ul>

            <!-- <div *ngIf="project.SDG13_OperationalCarbon">
              <h3 class="core-sdg__title">Operational carbon</h3>
              <ul class="core-sdg__list">
                <li class="core-sdg__list__item is--active">
                  <p>{{ project.SDG13_OperationalCarbon }} KG/M2</p>
                </li>
              </ul>
            </div> -->

            <!-- <h3 class="core-sdg__title">Has Water strategy</h3> -->
            <ul class="core-sdg__list" [class.mb-0]="!project.SDG13_WaterStrategy">
              <li class="core-sdg__list__item" [class.is--active]="project.SDG13_WaterStrategy">
                <svg class="icon-svg icon-check" *ngIf="project.SDG13_WaterStrategy">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>
                {{ project.SDG13_WaterStrategy ? 'Water strategy' : 'No Water strategy' }}
              </li>
              <li *ngIf="project.SDG13_WaterStrategyText">
                <p class="pre-line">{{ project.SDG13_WaterStrategyText }}</p>
              </li>
            </ul>
            <!-- <div *ngIf="project.SDG13_WaterStrategyText">
              <h3 class="core-sdg__title">Water strategy</h3>
              <ul class="core-sdg__list">
                <li class="core-sdg__list__item is--active">
                  <p class="pre-line">{{ project.SDG13_WaterStrategyText }}</p>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </app-expansion-panel>
      <app-expansion-panel [title]="'Resilience'" [active]="hidePanels.includes('resilience')" (toggle)="togglePanel('resilience')">
        <section class="core-sdg">
          <div class="core-sdg__content no--border" *ngIf="project.ResilliencePrinciples.length">
            <h3 class="core-sdg__title">Resilience Principles</h3>
            <ul class="core-sdg__list mb-0">
              <li class="core-sdg__list__item is--active" *ngFor="let principle of project.ResilliencePrinciples">
                <svg class="icon-svg icon-check">
                  <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
                </svg>
                {{ principle.Name }}
              </li>
            </ul>
          </div>

          <div class="core-sdg__content no--border" *ngIf="project.ResilliencePhaseDocument">
            <h3 class="core-sdg__title">Resilience phase document</h3>
            <ul class="core-sdg__list">
              <li class="core-sdg__list__item is--active">
                <p>{{ project.ResilliencePhaseDocument }}</p>
              </li>
            </ul>
          </div>
        </section>
        <section
          class="core-sdg"
          *ngIf="
            project.Challenge_CollectiveCommitment ||
            project.Challenge_SocialEquity ||
            project.Challenge_DecliningResources ||
            project.Challenge_DisasterPreparedness ||
            project.Challenge_Robustness ||
            project.Challenge_ClimateAdaption ||
            project.Challenge_LinkingTimes
          "
        >
          <div class="code-sdg__content">
            <h3 class="resillience-title">Resilience Challenges</h3>
            <div class="core-sdg__list">
              <app-resilience-challenge-list
                [challenges]="project.Challenge_CollectiveCommitment | split: ','"
                title="Collective commitment"
              ></app-resilience-challenge-list>
              <app-resilience-challenge-list
                [challenges]="project.Challenge_SocialEquity | split: ','"
                title="Social equity, diversity & accessibility"
              ></app-resilience-challenge-list>
              <app-resilience-challenge-list
                [challenges]="project.Challenge_DecliningResources | split: ','"
                title="Declining Resources"
              ></app-resilience-challenge-list>
              <app-resilience-challenge-list
                [challenges]="project.Challenge_DisasterPreparedness | split: ','"
                title="Disaster preparedness"
              ></app-resilience-challenge-list>
              <app-resilience-challenge-list
                [challenges]="project.Challenge_Robustness | split: ','"
                title="Robustness & flexibility"
              ></app-resilience-challenge-list>
              <app-resilience-challenge-list
                [challenges]="project.Challenge_ClimateAdaption | split: ','"
                title="Water & climate adaptation"
              ></app-resilience-challenge-list>
              <app-resilience-challenge-list
                [challenges]="project.Challenge_LinkingTimes | split: ','"
                title="Linking times, scales, hierarchies and expertises"
              ></app-resilience-challenge-list>
            </div>
          </div>
        </section>
      </app-expansion-panel>
    </section>

    <!-- TAB: GENERAL -->
    <div *ngIf="activeTab === 0">
      <app-expansion-panel [title]="'General info'" [active]="hidePanels.includes('general')" (toggle)="togglePanel('general')">
        <dl class="block-collapsable block-group-list">
          <dt *ngIf="project.Phase" class="block-group-heading is--inline">Phase:</dt>
          <dd *ngIf="project.Phase" class="block-group-item">{{ phaseLookup[project.Phase] }}</dd>

          <dt *ngIf="project.Year" class="block-group-heading is--inline">Year:</dt>
          <dd *ngIf="project.Year" class="block-group-item">&nbsp;{{ project.Year }}</dd>

          <dt *ngIf="project.Country" class="block-group-heading is--inline">Location:</dt>
          <dd *ngIf="project.Country" class="block-group-item">&nbsp;{{ project.Country.Name }}</dd>

          <dt *ngIf="project.City" class="block-group-heading is--inline">City:</dt>
          <dd *ngIf="project.City" class="block-group-item">&nbsp;{{ project.City }}</dd>

          <dt *ngIf="project.ClientName" class="block-group-heading is--inline">Client:</dt>
          <dd *ngIf="project.ClientName" class="block-group-item">&nbsp;{{ project.ClientName }}</dd>

          <dt *ngIf="project.ClientType" class="block-group-heading is--inline">Confidentiality:</dt>
          <dd *ngIf="project.ClientType" class="block-group-item">{{ project.ClientType == 0 ? 'Undisclosed' : 'Disclosed' }}</dd>

          <dt *ngIf="project.Budget" class="block-group-heading is--inline">Budget:</dt>
          <dd *ngIf="project.Budget" class="block-group-item">{{ project.Budget }}</dd>

          <dt class="block-group-heading is--inline">Height:</dt>
          <dd class="block-group-item">
            {{ project.HeightType === 1 ? 'High rise' : 'Low rise' }}
            <span *ngIf="project.Height > 0">({{ project.Height }}m)</span>
          </dd>

          <dt *ngIf="project.Size" class="block-group-heading is--inline">Program size total:</dt>
          <dd *ngIf="project.Size" class="block-group-item">{{ project.Size.toLocaleString() }} m2</dd>

          <dt *ngIf="project.FloorAreaRatio" class="block-group-heading is--inline">Floor Area Ratio:</dt>
          <dd *ngIf="project.FloorAreaRatio" class="block-group-item">{{ project.FloorAreaRatio }}</dd>

          <ng-container *ngIf="project.Typologies?.length > 0">
            <dt class="block-group-heading is--inline">Typologies:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.Typologies">{{ item.Name }}</dd>
          </ng-container>

          <ng-container *ngIf="project.Materials?.length > 0">
            <dt class="block-group-heading">Materials:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.Materials">{{ item.Name }}</dd>
          </ng-container>

          <ng-container *ngIf="project.Programs?.length > 0">
            <dt class="block-group-heading">Programs:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.Programs">{{ item.Name }}</dd>
          </ng-container>

          <ng-container *ngIf="project.Scales?.length > 0">
            <dt class="block-group-heading">Scales:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.Scales">{{ item.Name }}</dd>
          </ng-container>

          <ng-container *ngIf="project.Concepts?.length > 0">
            <dt class="block-group-heading">Concepts:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.Concepts">{{ item.Name }}</dd>
          </ng-container>

          <ng-container *ngIf="project.Structures?.length > 0">
            <dt class="block-group-heading">Structures:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.Structures">{{ item.Name }}</dd>
          </ng-container>

          <ng-container *ngIf="project.SustainabilityCertificates?.length > 0">
            <dt class="block-group-heading">Sustainability Certificates:</dt>
            <dd class="block-group-item is--comma" *ngFor="let item of project.SustainabilityCertificates">{{ item.Name }}</dd>
          </ng-container>
        </dl>
      </app-expansion-panel>

      <app-expansion-panel
        [title]="group.category || 'Photo group'"
        [active]="group.active"
        (toggle)="group.active = !group.active"
        *ngFor="let group of groupedImages"
      >
        <ul class="block-gallery-list">
          <li
            class="block-gallery-list-item type-{{ image.type }}"
            [ngClass]="{
              'is--active': image.active,
              'type-portrait': image.orientation === 'PORTRAIT',
              'type-landscape': image.orientation === 'LANDSCAPE'
            }"
            (click)="image.active = !image.active"
            *ngFor="let image of group.items"
          >
            <figure class="block-gallery-item-image-crop">
              <img [src]="image.ImageUrl" (load)="imageLoaded(image, $event)" />
            </figure>
            <figcaption *ngIf="image.Caption" class="caption block-gallery-item-image-crop-caption">{{ image.Caption }}</figcaption>
          </li>
        </ul>
      </app-expansion-panel>
      <!-- DETAILS -->

      <app-expansion-panel
        *ngIf="project.Details?.length > 0"
        [title]="'Used details'"
        [active]="detailsActive"
        (toggle)="detailsActive = !detailsActive"
      >
        <ul class="teasers-group type-flex-3">
          <li class="item teaser-item is--clickable" *ngFor="let d of project.Details">
            <app-teaser-block [teaserItem]="d | teaserItem"></app-teaser-block>
          </li>
        </ul>
      </app-expansion-panel>
    </div>
  </div>
</article>
